import { FormikHelpers } from 'formik';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import ChangeStatus from '../ChangeStatus/index';
import { PERSONAL_ITEMS_QR_GLU } from '../ChangeStatus/PERSONAL_ITEMS_QR_GLU';
import Loader from 'components/base/Loader';

import Modal from 'components/base/Modal';
import config from 'config';

import { MissingIncinerationAuthorizationError } from 'config/apiErrors/MissingIncinerationAuthorizationError';
import { UnprocessableEntityError } from 'config/apiErrors/UnprocessableEntityError';
import { StatusCodes } from 'models/OrderStatus';
import OrderType from 'models/OrderType';
import { QRType } from 'models/QRType';
import { ChangeStatusFormProps } from 'models/Workorder';
import { showErrorToast, showSuccessToast } from 'utils/toasts';

type FinishOrderProps = {
  show: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onHide: () => any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onSuccess: () => any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  order: any;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const FinishOrder = ({
  show, onHide, onSuccess, order,
}: FinishOrderProps) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState<boolean>(false);

  const sendFinishOrder = (
    params: ChangeStatusFormProps,
    actions: FormikHelpers<ChangeStatusFormProps>,
  ) => {
    setLoading(true);
    config.apiFunus.workOrder
      .changeStatus(order.id, {
        ...params,
        changeState: true,
        info: {
          ...params.info,
          qrs: [
            ...params.info.personalItemsQr?.split(PERSONAL_ITEMS_QR_GLU)
              .map((qr) => ({
                content: qr,
                type: QRType.PERSONAL_ITEM,
              })) || [],
          ],
        },
        infoQr: order.infoQr || {},
      })
      .then(() => {
        setLoading(false);
        showSuccessToast(t('order.finished'));
        onSuccess();
        return true;
      })
      .catch((error) => {
        setLoading(false);
        if (error instanceof UnprocessableEntityError) {
          showErrorToast(t(error.message));
        } else if (error instanceof MissingIncinerationAuthorizationError) {
          showErrorToast(t(error.message));
        } else {
          showErrorToast(t('order.notFinished'));
        }
        actions.setSubmitting(false);
      });
  };

  return (
    <Modal
      className="workorder-card-modal"
      closeOnFocusLost={false}
      show={show}
      showCancel={false}
      title={t('order.finishOrder')}
      onHide={onHide}
    >
      {loading && <Loader />}
      <ChangeStatus
        loading={false}
        order={order}
        showComment={order.status === StatusCodes.IN_PROGRESS}
        showDeposit={
          order.status === StatusCodes.IN_PROGRESS
          && (order.type === OrderType.PICKUP
            || (order.type === OrderType.RECEPTION && !order?.infoQr?.coffinQr))
          }
        showSecondQr={
            order.status === StatusCodes.IN_PROGRESS
            && order.type === OrderType.PREPARATION
          }
        showVigil={
            order.status === StatusCodes.IN_PROGRESS
            && order.type === OrderType.PREPARATION
          }
        onSubmit={sendFinishOrder}
      />
    </Modal>
  );
};
